function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "Path_22155",
  "data-name": "Path 22155",
  d: "M2547.693,1410.34l-6.334-6.213,6.333-6.212a2.868,2.868,0,1,0-4.016-4.095l-6.413,6.29-6.413-6.29a2.9,2.9,0,0,0-2.036-.821,2.869,2.869,0,0,0-1.98,4.916l6.334,6.212-6.333,6.213a2.868,2.868,0,1,0,4.016,4.095l6.413-6.29,6.413,6.29a2.868,2.868,0,0,0,4.016-4.1Z",
  transform: "translate(-2525.975 -1393)"
});

var SvgX = function SvgX(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 22.578,
    height: 22.256,
    viewBox: "0 0 22.578 22.256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgX, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/X.d2297a44.svg";
export { ForwardRef as ReactComponent };